import { ServiceClass_Read, ServiceClass_Read_Nested } from '@treadinc/horizon-api-spec';
import dayjs, { Dayjs } from 'dayjs';

import { CompanyBasic } from '~hooks/useCompany/models';
import { ItemNameAndId } from '~types/ItemNameAndId';
import { Nullable } from '~types/Nullable';
import { DEFAULT_PALETTE_COLOR } from '~utils/colors';

export class BasicServiceClass extends ItemNameAndId {
  public static parse(proto: ServiceClass_Read_Nested) {
    return new BasicServiceClass(
      proto.id ?? '',
      proto.name ?? '',
      proto.color ?? DEFAULT_PALETTE_COLOR,
      proto.discarded_at ? dayjs(proto.discarded_at) : null,
    );
  }
  constructor(
    _id: string,
    _name: string,
    private _color: string = DEFAULT_PALETTE_COLOR,
    private _discarded_at: Dayjs | null = null,
  ) {
    super(_name, _id);
  }

  public get color() {
    return this._color;
  }

  public get discardedAt() {
    return this._discarded_at;
  }
}

export class ServiceClass {
  public static parse(proto: ServiceClass_Read) {
    return new ServiceClass(
      proto.id ?? '',
      proto.name ?? '',
      proto.company ? CompanyBasic.parse(proto.company) : null,
      dayjs(proto.created_at),
      dayjs(proto.updated_at),
      proto.color ?? DEFAULT_PALETTE_COLOR,
      proto.discarded_at ? dayjs(proto.discarded_at) : null,
    );
  }

  public get id() {
    return this._id;
  }

  public get name() {
    return this._name;
  }

  public get company() {
    return this._company;
  }

  public get createdAt() {
    return this._createdAt;
  }

  public get updatedAt() {
    return this._updatedAt;
  }

  public get color() {
    return this._color;
  }

  public get discardedAt() {
    return this._discarded_at;
  }

  constructor(
    private _id: string,
    private _name: string,
    private _company: Nullable<CompanyBasic>,
    private _createdAt: Dayjs,
    private _updatedAt: Dayjs,
    private _color: string = DEFAULT_PALETTE_COLOR,
    private _discarded_at: Dayjs | null = null,
  ) {}
}
